import { css } from 'styled-system/css';
import { ChatLine } from './ChatLine';

export function ChatOverlay({ open = false }: { open?: boolean }) {
  return (
    <div
      data-open={open || undefined}
      className={css({
        position: 'absolute',
        inset: '3',
        left: 'auto',
        zIndex: 2,
        width: { base: '58%', md: '46%' },
        display: 'grid',
        gridTemplateRows: '0fr',
        alignContent: 'end',
        transition: 'grid-template-rows 400ms {easings.out}',
        pointerEvents: 'none',
        _motionReduce: { transition: 'none' },
        '&[data-open]': { gridTemplateRows: '1fr' },
      })}
    >
      <div
        className={css({
          overflow: 'hidden',
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
        })}
      >
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            gap: '3',
            flex: 1,
            minHeight: 0,
            padding: '4',
            background: 'bg.surface',
            border: '1px solid token(colors.border.hairline)',
            borderRadius: '12px',
            overflow: 'hidden',
          })}
        >
          <span>Agent</span>
          <ChatLine who="You" right body="which stocks are growing?" />
          <ChatLine
            who="Exis AI"
            agent
            body={[
              'NVDA, MSFT, and TSLA. Net is +4%, +3%, and +2%. GOOGL is up +1%. The rest of the sheet is flat or down.',
              'I can sort by Net and put the growers first, if you want.',
            ]}
          />
          <div
            className={css({
              marginTop: 'auto',
              paddingTop: '3',
              borderTop: '1px solid token(colors.border.hairline)',
              fontFamily: 'mono',
              fontSize: '2xs',
              color: 'text.faint',
            })}
          >
            Message the sheet…
          </div>
        </div>
      </div>
    </div>
  );
}
